import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5f5479bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "statistics-title" }, "Статистика расходов")
], -1))

import { computed, ref, onMounted, onUpdated, onUnmounted } from "vue";
import { useAuthStore } from "@/store/auth/login";
import {
  useStatisticsStore,
  StatisticsParams,
  StatisticsFilter,
} from "@/store/expenses/statistics";
import { setStatisticsParamsByFilter } from "@/services/expenses/statistics";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import StatisticsCards from "@/widgets/statistics/StatisticsCards.vue";
import StatisticsFilters from "@/widgets/statistics/StatisticsFilters.vue";
import StatisticsItemsTable from "@/entities/expenses/StatisticsItemsTable.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import Paginator from "primevue/paginator";
import { rootGetters } from "@/main";
import { rowsCount } from "@/services/utils/Pagination";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsPage',
  setup(__props) {

const authStore = useAuthStore();
const statisticsStore = useStatisticsStore();

const headerContainerRef = ref<HTMLElement | null>(null);
const headerHeight = ref(350);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions([
    "expenses:read",
    "expenses:edit",
    "system:read",
    "system:edit",
  ]);
});

const isItemsLoading = ref(false);
const itemsTableDisplaySettings = ref({
  first: 0,
  orderField: "",
  filter: {
    brand: [] as string[],
    segment: [] as number[],
    ads_cabinet: [] as number[],
    date: null as any,
    state: [] as number[],
    platform: [] as string[],
  } as StatisticsFilter,
});

const applyFilter = (filter: StatisticsFilter) => {
  itemsTableDisplaySettings.value.filter = filter;
  itemsTableDisplaySettings.value.first = 0;
  updateItemsList();
};

const resetFilter = () => {
  itemsTableDisplaySettings.value.filter = {
    brand: [],
    segment: [],
    ads_cabinet: [],
    date: null,
    state: [],
    platform: [],
  };
  itemsTableDisplaySettings.value.first = 0;
  updateItemsList();
};

const sortItemsTable = (order_by: string) => {
  itemsTableDisplaySettings.value.orderField = order_by;
  updateItemsList();
};

const updateItemsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isItemsLoading.value = true;
    }
  }, 200);

  const calculatedPerPage = rowsCount(43);
  const params: StatisticsParams = {
    page: itemsTableDisplaySettings.value.first + 1,
    per_page: Math.min(calculatedPerPage, 100),
  };

  setStatisticsParamsByFilter(params, itemsTableDisplaySettings.value);

  statisticsStore.getSegmentCosts(params).finally(() => {
    isItemsLoading.value = false;
    isEnded = true;
  });
};

const updateHeaderHeight = () => {
  if (headerContainerRef.value) {
    headerHeight.value = headerContainerRef.value.offsetHeight;
  }
};

onMounted(() => {
  loadItemsData();
  updateHeaderHeight();
  window.addEventListener("resize", updateHeaderHeight);
});

onUpdated(() => {
  updateHeaderHeight();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateHeaderHeight);
});

const loadItemsData = () => {
  isItemsLoading.value = true;
  updateItemsList();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "headerContainerRef",
            ref: headerContainerRef,
            class: "statistics-header-container"
          }, [
            _hoisted_1,
            _createVNode(StatisticsCards, {
              statistics: _unref(statisticsStore).statistics,
              "is-loading": isItemsLoading.value
            }, null, 8, ["statistics", "is-loading"]),
            _createVNode(StatisticsFilters, {
              "applied-filter": itemsTableDisplaySettings.value.filter,
              onApply: applyFilter,
              onReset: resetFilter
            }, null, 8, ["applied-filter"])
          ], 512),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            _unref(statisticsStore).items && _unref(statisticsStore).items.length == 0
              ? 'empty'
              : 'filled',
          ]]),
            style: _normalizeStyle({ '--header-height': headerHeight.value + 'px' })
          }, [
            _createVNode(StatisticsItemsTable, {
              items: _unref(statisticsStore).items,
              isActiveFirst: false,
              isLoading: isItemsLoading.value,
              rowsCount: _unref(rowsCount)(43) * itemsTableDisplaySettings.value.first,
              onSortTable: sortItemsTable
            }, null, 8, ["items", "isLoading", "rowsCount"]),
            (
              _unref(statisticsStore).items &&
              _unref(statisticsStore).items.length == 0 &&
              !isItemsLoading.value
            )
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Нет данных для отображения. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 6),
          _createVNode(_unref(Paginator), {
            first: itemsTableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[0] || (_cache[0] = ($event: any) => ((itemsTableDisplaySettings.value.first) = $event)),
              updateItemsList
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(statisticsStore).itemsPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})